import { render, staticRenderFns } from "./PrintTem.vue?vue&type=template&id=1806951b&scoped=true&"
import script from "./PrintTem.vue?vue&type=script&lang=js&"
export * from "./PrintTem.vue?vue&type=script&lang=js&"
import style0 from "./PrintTem.vue?vue&type=style&index=0&id=1806951b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1806951b",
  null
  
)

export default component.exports